export const DELETE_PATIENT_PROFILES_TOOL_NAME = 'delete_patient_profiles';

/** Patients whose name and linked sessions are loaded on the approval card. */
export const MAX_PATIENTS_WITH_DETAILS = 10;

export interface DeletePatientProfilesApprovalFields {
  patientProfileIds: string[];
  deleteLinkedSessions: boolean | undefined;
}

export const readDeletePatientProfilesApprovalFields = (
  input: Record<string, unknown>
): DeletePatientProfilesApprovalFields => {
  const rawIds = Array.isArray(input.patient_profile_ids)
    ? input.patient_profile_ids
    : [];
  const patientProfileIds = [
    ...new Set(
      rawIds.filter((id): id is string => typeof id === 'string' && id.trim().length > 0)
    ),
  ];
  const deleteLinkedSessions =
    typeof input.delete_linked_sessions === 'boolean'
      ? input.delete_linked_sessions
      : undefined;
  return { patientProfileIds, deleteLinkedSessions };
};
